import { useAteraAgents } from '../hooks/useAgents';
import AgentList, { Pill, fmtWhen } from '../components/AgentList';

// What Atera actually holds, right now — not the devices register's cached
// atera_agent flag, which is set by the nightly sync and never cleared, so it
// keeps reporting machines whose agent has long since gone.

function AteraAgents() {
  const { data, isLoading, isFetching, error, refetch } = useAteraAgents();

  const columns = [
    { key: 'hostname', label: 'Machine', render: (a) => <span className="font-medium text-gray-900">{a.hostname || '—'}</span> },
    { key: 'serial', label: 'Serial', render: (a) => <span className="font-mono text-xs">{a.serial || '—'}</span> },
    { key: 'model', label: 'Model', render: (a) => a.model || '—' },
    { key: 'last_user', label: 'Last user', render: (a) => a.last_user || '—' },
    {
      key: 'online',
      label: 'State',
      render: (a) => <Pill ok={a.online}>{a.online ? 'online' : 'offline'}</Pill>,
    },
    { key: 'last_seen', label: 'Last seen', render: (a) => <span className="whitespace-nowrap text-gray-500">{fmtWhen(a.last_seen)}</span> },
    {
      key: 'in_register',
      label: 'Register',
      render: (a) => (a.in_register
        ? <span className="text-xs text-gray-500">{a.assigned_name || 'known'}</span>
        : <span className="text-xs font-medium text-amber-700">not in register</span>),
    },
  ];

  return (
    <AgentList
      title="Atera Agents"
      blurb="Every machine reporting into Atera, read live from Atera each time you refresh. Use it to confirm an enrolment has landed without signing into the Atera console."
      data={data}
      isLoading={isLoading}
      isFetching={isFetching}
      error={error}
      refetch={refetch}
      stats={[
        { label: 'agents', value: data?.total ?? '—' },
        { label: 'online now', value: data?.online ?? '—' },
        { label: 'not in register', value: data?.unknown ?? '—' },
      ]}
      columns={columns}
      searchFields={['hostname', 'serial', 'model', 'last_user', 'assigned_name']}
    />
  );
}

export default AteraAgents;
